import React from "react";
import { motion } from "framer-motion";
import { useMotion } from "../../../Logic/Functions/Hooks/useMotion";
import styles from "./Aboutus.module.css";
import { ICategoryCardProps } from "../../../Model/Aboutus.model";



const CategoryOffer: React.FC<ICategoryCardProps> = ({
  title,
  description,
  icon,
  imageSrc,
  animateFrom = "up",
  delay = 0,
  once = true,
  triggerAmount = 0.3,
  className = "",
}) => {
  const { slideFade } = useMotion();

  return (
    <motion.article
      className={`${styles.catCard} ${className}`}
      data-testid="cat-card"
      variants={slideFade(animateFrom, delay)}
      initial="hidden"
      whileInView="show"
      viewport={{ once, amount: triggerAmount }}
      whileHover={{ y: -4, scale: 1.01 }}
      transition={{ duration: 0.2 }}
    >
      <div className={styles.catMedia}>
        {icon ? (
          <div className={styles.catIconWrap} aria-hidden>
            {icon}
          </div>
        ) : imageSrc ? (
          <div className={styles.catImgWrap} >
            <img src={imageSrc} alt={title} className={styles.catImg} />
          </div>
        ) : null}
      </div>

      <h3 className={styles.catTitle} data-testid="cat-card-title">
        {title}
      </h3>

      {description && (
        <p className={styles.catDesc} data-testid="cat-card-desc">
          {description}
        </p>
      )}
    </motion.article>
  );
};

export default CategoryOffer;
